<script>
export default {
    props: {
        currentPage: {
            type: Number,
            required: true
        },
        maxPages: {
            type: Number,
            required: true
        }
    },
    computed: {
        hasPrev () {
            return this.currentPage > 1;
        },
        hasNext () {
            return this.currentPage < this.maxPages;
        }
    },
    methods: {
        goPrev () {
            if (this.hasPrev) {
                this.$emit('prev');
            }
        },
        goNext () {
            if (this.hasNext) {
                this.$emit('next');
            }
        },
    }
}
</script>
<template>
    <div class="pagination-control">
        <div class="pagination-control__controls">
            <div :class="{'pagination-control__button--disabled': !hasPrev}"
                 class="pagination-control__button pagination-control__button--prev"
                 @click="goPrev"/>
            <div :class="['pagination-control__info', (maxPages > 99) ? 'pagination-control__info--small' : null]">
                {{ currentPage }} / {{ maxPages }}
            </div>
            <div :class="{'pagination-control__button--disabled': !hasNext}"
                 class="pagination-control__button pagination-control__button--next"
                 @click="goNext"/>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/PaginationControl/PaginationControl.vue